import { useRef, useState, useEffect } from 'react';
import { SEARCH_BY_ENTITIES } from 'store/Filters/entitiesConstants';
import { redirect } from 'store/Router/actions';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { generalView } from 'store/Tabs/selectors';

export function shouldRedirect (selectedEntityPathname, entityName, currentEntityView) {
  return (dispatch, getState) => {
    const isOutsideWorkspace = generalView(getState());
    const selectedWorkspace = selectCurrentWorkspace(getState());
    if (!currentEntityView.includes(entityName) && isOutsideWorkspace) {
      const pathToRedirect = SEARCH_BY_ENTITIES.find((e) => e.name.value.includes(entityName) && !e.wsDependant)?.pathname;
      dispatch(redirect(`/${pathToRedirect}`));
    } else if (selectedEntityPathname && (currentEntityView !== selectedEntityPathname) && !currentEntityView.includes(entityName)) {
      const pathToRedirect = SEARCH_BY_ENTITIES.find((e) => e.name.value.includes(entityName) && e.wsDependant)?.pathname;
      dispatch(redirect(`/${pathToRedirect}/${selectedWorkspace}`));
    }
  };
}

export const useKeyPress = function (targetKey) {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const downHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(true);
      }
    };

    const upHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  });

  return keyPressed;
};

export const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => { htmlElRef.current && htmlElRef.current.focus(); };
  const setBlur = () => { htmlElRef.current && htmlElRef.current.blur(); };
  return [htmlElRef, setFocus, setBlur];
};

export const filterByInput = (options, inputValue) => {
  const filterCriteria = (option) => (
    option?.name?.value?.toLowerCase().includes(inputValue.toLowerCase()) ||
      option?.name?.label?.toLowerCase().includes(inputValue.toLowerCase())
  );

  const filterResult = options.filter(filterCriteria);
  if (filterResult.length > 0) return filterResult;
  return options;
};
